import { FieldSchemaEditorSupportedTypes } from 'dashboard/components-lib/FieldSchemaEditor/constants';
import { getAllFields } from 'dashboard/components-lib/FieldSchemaEditor/utils';
import { singleFieldSchemaError } from 'dashboard/components-lib/FieldSchemaEditor/validation';

const findNonUniqueKeys = (fieldSchemas: FieldSchemaEditorSupportedTypes[]): string[] => {
  const uniqueKeys = new Set<string>();
  const nonUniqueFieldPaths = new Set<string>();
  const allFields = getAllFields(fieldSchemas);
  for (let i = 0; i < allFields.length; i++) {
    if (uniqueKeys.has(allFields[i].key)) {
      nonUniqueFieldPaths.add(allFields[i].path);
    }
    uniqueKeys.add(allFields[i].key);
  }
  return Array.from(nonUniqueFieldPaths);
};

export const validateAllSchemas = (fieldSchemas: FieldSchemaEditorSupportedTypes[]): string[] => {
  return Object.values(getAllFields(fieldSchemas))
    .filter(({ fieldSchema }) => {
      const { message } = singleFieldSchemaError(fieldSchema);
      return !!message;
    })
    .map(({ path }) => path)
    .concat(findNonUniqueKeys(fieldSchemas));
};
